import type { LegalSection } from './legal-section';

export const PRIVACY_CONTROLLER: readonly LegalSection[] = [
  {
    title: '1. Responsable del tratamiento',
    body: `Responsable: La divina comedia sa, con domicilio en Calle Ricardo J Alfaro, Edificio PH the century tower, oficina 317, Panamá (código postal 0830). Email de privacidad: support@debook.app.

Las solicitudes en materia de protección de datos se atenderán a través del email de contacto indicado.`,
  },
  {
    title: '2. Datos personales que recogemos del Collector',
    body: `Identificativos: nombre, apellidos, fecha de nacimiento, país y ciudad de residencia.

Contacto: dirección de correo electrónico, número de móvil con prefijo internacional.

Identidad digital: usuario público de Instagram.

Datos de pago: dirección de wallet USDC (imprescindible para la ejecución del contrato).

Datos técnicos: huella digital del dispositivo (device fingerprint), dirección IP, información del navegador y registros de actividad.`,
  },
  {
    title: '3. Finalidades y bases jurídicas',
    body: `(a) Operar el programa de Collectors (registro, cálculo de compensación, pagos): ejecución del contrato (art. 6.1.b RGPD).

(b) Cumplir obligaciones legales (fiscales, prevención de blanqueo): obligación legal (art. 6.1.c RGPD).

(c) Construir base de datos B2B de creadores: interés legítimo (art. 6.1.f RGPD).

(d) Prevenir fraude mediante huella digital: interés legítimo (art. 6.1.f RGPD).

AVISO SOBRE CRIPTOACTIVOS Y PRIVACIDAD: el tratamiento de la dirección de su wallet es un requisito contractual. Al aceptar estos términos, consiente el registro de su identificador de wallet en redes blockchain públicas para la ejecución de pagos en USDC.`,
  },
];
